
const contactUs = {
  'contactUs.title': 'Kontaktiere uns',
  'contactUs.subtitle': 'Wir sind hier, um zu helfen',
  'contactUs.whatsapp.title': 'Kontaktiere uns über WhatsApp',
  'contactUs.email.title': 'Kontaktiere uns per E-Mail',
  'contactUs.whatsapp.urgent': 'Für dringende Anfragen kontaktiere uns direkt über WhatsApp. Unser Team wird dir so schnell wie möglich antworten.',
  'contactUs.languages.english': 'English',
  'contactUs.languages.italian': 'Italiano',
  'contactUs.languages.spanish': 'Español',
  'contactUs.languages.german': 'Deutsch',
  'contactUs.languages.croatian': 'Hrvatski',
  'contactUs.languages.turkish': 'Türkçe',
  'contactUs.languages.french': 'Français',
  'contactUs.languages.arabic': 'العربية',
};

export default contactUs;
